/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-param-reassign */
import { RETRY_LIMIT } from '@constants';
import AuthService from '@services/auth';
import TokenService from '@services/token';
import axios, { AxiosError, AxiosHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { AUTH_SERVICE_URL } from '../constants/externalRoutes';
import { conditionalRedirect } from './navigation';

interface RetryAxiosRequestConfig extends InternalAxiosRequestConfig {
  _retry: boolean;
  _retryCount?: number;
}

const axiosConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Accept-Language': 'en',
  },
};

const instance = axios.create(axiosConfig);
const {
  interceptors: { request, response },
} = instance;

const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const contentType =
    config.headers && config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/json';

  const headers = new AxiosHeaders();
  headers.set('Accept', 'application/json');
  headers.set('Content-Type', contentType);
  headers.set('Accept-Language', 'en');
  config.headers = headers;

  return config;
};

const responseErrorInterceptor = async (err: AxiosError): Promise<AxiosError> => {
  const originalConfig = err.config as RetryAxiosRequestConfig;

  if (!originalConfig) {
    return Promise.reject(err);
  }

  // Check if this is already a refresh token request - if so, don't try to refresh again
  const isRefreshTokenRequest = originalConfig.url?.includes('/refreshToken');
  if (isRefreshTokenRequest && (err.response?.status === 401 || err.response?.status === 403)) {
    // Clear the token to ensure clean state
    TokenService.removeRefreshToken();
    const url = `${AUTH_SERVICE_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
    conditionalRedirect(url, 'replace');
    return Promise.reject(err);
  }

  // Initialize retry count for this specific request
  if (!originalConfig._retryCount) {
    originalConfig._retryCount = 0;
  }

  originalConfig._retryCount++;

  if (err.response) {
    // Access Token was expired (401 from Discovery, 403 from Lambda Authorizer)
    if ((err.response.status === 401 || err.response.status === 403) && !originalConfig._retry) {
      // Check if this specific request has exceeded its retry limit
      if (originalConfig._retryCount >= RETRY_LIMIT) {
        const url = `${AUTH_SERVICE_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
        conditionalRedirect(url, 'replace');
        return Promise.reject(err);
      }

      originalConfig._retry = true;

      try {
        await AuthService.authorize();
        // Reset retry count for this request on successful auth
        originalConfig._retryCount = 0;
        return await instance(originalConfig);
      } catch (_error) {
        const url = `${AUTH_SERVICE_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
        conditionalRedirect(url, 'replace');
        return Promise.reject(_error);
      }
    }
  }

  return Promise.reject(err);
};

const responseInterceptor = (res: AxiosResponse): AxiosResponse => res;

const requestErrorInterceptor = (error: AxiosError): Promise<AxiosError> => Promise.reject(error);

request.use(requestInterceptor, requestErrorInterceptor);
response.use(responseInterceptor, responseErrorInterceptor);

export default instance;

export const downloadFileResponse = (responseData: BlobPart, options: { filename: string }) => {
  const filename = decodeURI(options.filename);

  const url = window.URL.createObjectURL(new Blob([responseData]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);

  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
};
